import { FC } from 'react'
import { Link } from 'react-scroll'
import { MotionProvider } from '../Providers/MotionProvider'
interface HomeProps {}

const Home: FC<HomeProps> = () => {
  return (
    <div
      className="bloc bloc-fill-screen bloc-bg-texture texture-darken-strong d-bloc"
      id="home-section"
    >
      <div className="container fill-bloc-top-edge">
        <div className="row">
          <div
            className="col-12 animated zoomIn"
            data-appear-anim-style="zoomIn"
          >
            <nav
              className="navbar row navbar-dark flex-column"
              role="navigation"
            >
              <div className="navbar-brand mx-auto">
                <MotionProvider>
                  <img
                    className="App-logo"
                    src="./img/Universal_Applications_Consulting_BL_white_small.png"
                    alt="logo"
                  />
                </MotionProvider>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div
            className="col offset-lg-0 col-lg-12 animated zoomIn"
            data-appear-anim-style="zoomIn"
          >
            <h1 className="mg-md float-none text-center h3-style text-white font-italic">
              We build your future.
            </h1>
            <div className="text-center">
              <Link
                className="btn btn-lg btn-wire"
                activeClass="active"
                to="about-section"
                spy={false}
                smooth={true}
                offset={0}
                duration={1000}
              >
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home
